import { postRequest, putRequest } from "../utils/api.utils";

export const resetPassword = (resetCode: string, password: string) =>
  putRequest("/api/auth/reset-password", { resetCode, password });

export const forgotPassword = (email: string) => postRequest("/api/auth/forgot-password", { email });

export const newPasswordRequest = (oldPassword: string, newPassword: string) =>
  putRequest("/api/auth/password", { oldPassword, newPassword });
